<template>
  <div class="module hero-module container-fluid">
    <div class="h3">Heroes</div>
    <p><em>Extra heroes only visible in version 4.x.</em></p>
    <div class=""></div>
    <ul id="hero-tabs" class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" href="#"
           v-bind:class="[ activeTab === 0 ? 'active' : '' ]" v-on:click="activeTab=0">Main hero</a>
      </li>
      <li v-for="(hero, index) in extraHeroes" class="nav-item">
        <a class="nav-link" href="#"
           v-bind:class="[ activeTab === index+1 ? 'active' : '' ]" v-on:click="activeTab=(index+1)">Extra hero
          {{ index + 1 }}</a>
      </li>
      <li class="nav-item" v-on:click="addHero">
        <a class="nav-link" href="#">+</a>
      </li>
    </ul>

    <div id="heroTabsContent" class="tab-content">
      <div class="tab-pane fade" role="tabpanel"
           v-bind:class="[ activeTab === 0 ? 'show active' : '' ]">
        <div class="row">
          <div class="form-group col">
            <label for="hero-image">Select image</label>
            <image-upload
                :hideRemoveButton="true"
                :imageUrl="getHeroImage(data)"
                @image-loaded="handleSelectImage($event)"
                @image-removed="$emit('hero-image-removed', $event)"
            />
          </div>
          <div class="form-group col-md-8">
            <label for="hero-link-type">Link to:</label>
            <select
                id="hero-link-type"
                class="custom-select form-control mb-3"
                @change="handleSelectLinkType($event)"
            >
              <option
                  v-for="linkType in linkTypes"
                  v-bind:key="linkType.name"
                  :selected="linkType.name == data.link_type"
                  :value="linkType.name"
              >{{ linkType.label }}
              </option>
            </select>

            <label for="hero-story">Select docu</label>
            <select
                id="hero-story"
                :disabled="this.data.link_type !== 'snick'"
                class="custom-select form-control mb-3"
                @change="handleSelectSnick($event)"
            >
              <option
                  v-for="(story, index)  in storyList"
                  v-bind:key="story.id"
                  :selected="story.id == data.story_id"
                  :value="story.id"
              >{{ story.title }}
              </option>
            </select>


            <label for="hero-collections">Select collection</label>
            <select
                id="hero-collections"
                :disabled="this.data.link_type !== 'collection'"
                class="custom-select form-control"
                @change="handleSelectCollection($event)"
            >
              <option
                  v-for="collection in collectionList"
                  v-bind:key="collection.id"
                  :selected="collection.id == data.collection_id"
                  :value="collection.id"
              >{{ collection.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-for="(hero, index) in extraHeroes" class="tab-pane fade"
           role="tabpanel"
           v-bind:class="[ activeTab === index+1 ? 'show active' : '' ]">
        <div class="row">
          <div class="form-group col">
            <label for="hero-image">Select image</label>
            <image-upload
                :hideRemoveButton="true"
                :imageUrl="getHeroImage(hero)"
                @image-loaded="handleSelectImage($event, index)"
                @image-removed="$emit('hero-image-removed', $event)"
            />
          </div>
          <div class="form-group col-md-8">
            <label for="hero-link-type">Link to:</label>
            <select
                id="hero-link-type"
                class="custom-select form-control mb-3"
                @change="handleSelectLinkType($event, index)"
            >
              <option
                  v-for="linkType in linkTypes"
                  v-bind:key="linkType.name"
                  :selected="linkType.name === hero.link_type"
                  :value="linkType.name"
              >{{ linkType.label }}
              </option>
            </select>

            <label for="hero-story">Select docu</label>
            <select
                id="hero-story"
                :disabled="hero.link_type !== 'snick'"
                class="custom-select form-control mb-3"
                @change="handleSelectSnick($event, index)"
            >
              <option
                  v-for="story in storyList"
                  v-bind:key="story.id"
                  :selected="story.id == hero.story_id"
                  :value="story.id"
              >{{ story.title }}
              </option>
            </select>

            <label for="hero-collections">Select collection</label>
            <select
                id="hero-collections"
                :disabled="hero.link_type !== 'collection'"
                class="custom-select form-control"
                @change="handleSelectCollection($event, index)"
            >
              <option
                  v-for="collection in collectionList"
                  v-bind:key="collection.id"
                  :selected="collection.id == hero.collection_id"
                  :value="collection.id"
              >{{ collection.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">

          <div class="form-group">
            <div class="button-container col-auto">
              <button class="btn btn-danger float-right" @click="removeHero(hero, index)">
                Remove hero
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stories: Array,
    collections: Array,
    data: Object,
    extraHeroes: Array,
    update: Object,
    image_path: String
  },

  data() {
    return {
      linkTypes: [
        {name: "snick", label: "Docu"},
        {name: "collection", label: "Collection"}
      ],
      activeTab: 0
    };
  },
  mounted() {
    if (!this.data.link_type) {
      this.$set(this.data, "link_type", "snick");
    }
  },
  computed: {
    storyList: function () {
      const stories = this.stories;
      stories.unshift({
        title: "-- Chose one --",
        id: null
      });
      return stories;
    },
    collectionList: function () {
      const collections = this.collections;
      collections.unshift({
        name: "-- Chose one --",
        id: null
      });
      collections.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );

      return collections;
    },
    image: function () {
      if (this.update) {
        return this.data.image;
      } else {
        return this.data.image;
      }
    }
  },

  methods: {
    toggleTab: function (event) {
      console.debug("toggleTab", event);
      $(this).tab("show");
    },
    addHero: function () {
      const newHero = {
        ...this.data,
        image: 'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAASwAAADICAYAAABS39xVAAACB0lEQVR42u3UMQ0AAAgEMfBvDFePCgaSVsIN15lJATzQhgUYFoBhAYYFYFgAhgUYFoBhARgWYFgAhgVgWIBhARgWgGEBhgVgWACGBRgWgGEBGBZgWACGBWBYgGEBGBaAYQGGBWBYgGEZFmBYAIYFGBaAYQEYFmBYAIYFYFiAYQEYFoBhAYYFYFgAhgUYFoBhARgWYFgAhgVgWIBhARgWgGEBhgVgWACGBRgWgGEBhmVYgGEBGBZgWACGBWBYgGEBGBaAYQGGBWBYAIYFGBaAYQEYFmBYAIYFYFiAYQEYFoBhAYYFYFgAhgUYFoBhARgWYFgAhgUYlmEBhgVgWIBhARgWgGEBhgVgWACGBRgWgGEBGBZgWACGBWBYgGEBGBaAYQGGBWBYAIYFGBaAYQEYFmBYAIYFYFiAYQEYFmBYMgCGBWBYgGEBGBaAYQGGBWBYAIYFGBaAYQEYFmBYAIYFYFiAYQEYFoBhAYYFYFgAhgUYFoBhARgWYFgAhgVgWIBhARgWYFgAhgVgWIBhARgWgGEBhgVgWACGBRgWgGEBGBZgWACGBWBYgGEBGBaAYQGGBWBYAIYFGBaAYQEYFmBYAIYFYFiAYQEYFmBYAIYFYFiAYQEYFoBhAYYFYFgAhgUYFoBhARgWYFgAhgVgWIBhARgWgGEBhgVgWACGBRgWgGEBGBZgWAB3FjRFx9fKKwwwAAAAAElFTkSuQmCC'
      };

      this.$emit("add-extra-hero", newHero);
      this.activeTab = this.extraHeroes.length;
    },
    removeHero: function (hero, index) {
      confirm('You are about to remove this hero. Are you sure?') && this.$emit("remove-extra-hero", {
        hero: hero,
        index: index
      });
      this.activeTab = index;
    },
    handleSelectLinkType: function (event, extraHeroIndex = null) {
      this.$emit("update-hero-link-type", {
        value: event.target.value,
        extraHeroIndex: extraHeroIndex
      });
    },
    handleSelectImage: function (event, extraHeroIndex = null) {
      // Convert image to base64 and pass it to the parent
      const reader = new FileReader();
      reader.onload = e => {
        const picture = e.target.result;
        this.$emit("update-hero-image", {
          value: picture,
          extraHeroIndex: extraHeroIndex
        });
      };
      reader.readAsDataURL(event);
    },
    handleSelectSnick: function (event, extraHeroIndex = null) {
      this.$emit("update-hero-snick", {
        value: event.target.value,
        extraHeroIndex: extraHeroIndex
      });
    },
    handleSelectCollection: function (event, extraHeroIndex = null) {
      this.$emit("update-hero-collection", {
        value: event.target.value,
        extraHeroIndex: extraHeroIndex
      });
    },
    getHeroImage: function (hero) {
      if (this.update && hero['image-data']) {
        return hero['image-data'];
      } else {
        return this.image_path.replace(/\/$/, '') + hero.image;
      }
    },
  }
};
</script>
